export default __webpack_public_path__ + "static/media/groupcall2.5e59923c.svg";